import script from "./Loader.vue?vue&type=script&lang=ts&setup=true"
export * from "./Loader.vue?vue&type=script&lang=ts&setup=true"

import "./Loader.vue?vue&type=style&index=0&id=14fa5f8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fa5f8e"]])

export default __exports__